<div class="callout-box" [class.tall]="isTall" [class.no-margins]="noMargins">
  <img [src]="icon" alt="" class="callout-icon" />
  <div class="callout-content">
    @if (title) {
      <p>
        <strong>{{ title }}</strong>
      </p>
    }
    <div [innerHTML]="content"></div>
  </div>
</div>
